var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":_vm.absolute,"value":_vm.isShow}},[_c('p',[_vm._v("ไม่สามารถดึงข้อมูลได้")]),_c('v-btn',{on:{"click":function($event){return _vm.$emit('reload-data')}}},[_vm._v(" รีเฟรชข้อมูล ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }